import React from 'react';
import {Col, Row, Container, Form, InputGroup, Button} from "react-bootstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import {config} from "./Constants";

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            submitError: null,
            isLoaded: true,
            isLoggedIn: false,
            isSubmitting: false,
            redirect: null,
            client: null
        };
        this.timeout = null;
        this.handleSearch = this.handleSearch.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }

    handleSearch(event){
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        if(this.timeout !== null){
            clearTimeout(this.timeout);
        }
        if(this.props.onSearch){
            this.props.onSearch(document.getElementById('searchBar').value);
        }
        return false;
    }

    handleKeyUp(event){
        if(this.timeout !== null){
            clearTimeout(this.timeout);
        }
        let that = this;
        this.timeout = setTimeout(function(){
            that.handleSearch();
        }, 500);
    }

    handleReset(event){
        if(this.timeout !== null){
            clearTimeout(this.timeout);
        }
        document.getElementById('searchBar').value = '';
        this.handleSearch();
    }

    render() {
        return (
            <React.Fragment>
                <form className="search-form" onSubmit={this.handleSearch}>
                    <InputGroup>
                        <Form.Control
                            placeholder={this.props.label}
                            aria-label={this.props.label}
                            id="searchBar"
                            onKeyPress={this.handleKeyUp}
                            onChange={this.handleKeyUp}
                        />
                        <InputGroup.Append>
                            <Button type="submit">
                                <FontAwesomeIcon icon={faSearch}/>
                            </Button>
                            <Button type="reset">
                                <FontAwesomeIcon icon={faTimesCircle} onClick={this.handleReset}/>
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                </form>
            </React.Fragment>
        )
    }
}

export default SearchBar;
